import {SectionBgView} from '../../../../shared/scripts/ui_canvas_engine/SectionBgView'
import {UIGameActionButtonView} from '../../../../shared/scripts/ui_game/ui_game_actions/UIGameActionButtonView'
import {UIGameActionButtonViewCity} from '../../../../shared/scripts/ui_game/ui_game_actions/UIGameActionButtonViewCity'
import {UIGameActionButtonViewRoad} from '../../../../shared/scripts/ui_game/ui_game_actions/UIGameActionButtonViewRoad'
import {UIGameActionButtonViewSettlement} from '../../../../shared/scripts/ui_game/ui_game_actions/UIGameActionButtonViewSettlement'
import {UIGameActionsController} from '../../../../shared/scripts/ui_game/ui_game_actions/UIGameActionsController'
import {UIGameActionButtonViewTrade} from '../../../../shared/scripts/ui_game/ui_game_actions/UIGameActionButtonViewTrade'
import {UIGameActionButtonViewTurn} from '../../../../shared/scripts/ui_game/ui_game_actions/UIGameActionButtonViewTurn'
import {MechanicCityState, MechanicRoadState, MechanicSettlementState} from '@colonist/game-states'

export class UIWGameActionsController extends UIGameActionsController {
    protected addDefaultButtons(settlementState: MechanicSettlementState | undefined,
                                cityState: MechanicCityState | undefined,
                                roadState: MechanicRoadState | undefined) {
        this.buttonViews.push(new UIGameActionButtonViewTrade(this.uiGameManager, this.container))
        if(roadState) this.buttonViews.push(new UIGameActionButtonViewRoad(this.uiGameManager, roadState, this.container))
        if(settlementState) this.buttonViews.push(new UIGameActionButtonViewSettlement(this.uiGameManager, settlementState, this.container))
        if(cityState) this.buttonViews.push(new UIGameActionButtonViewCity(this.uiGameManager, cityState, this.container))
        this.buttonViews.push(new UIGameActionButtonViewTurn(this.uiGameManager, this.container))
    }

    protected getContainer(): SectionBgView {
        const canvas = this.uiGameManager.canvasController
        const x = canvas.appW - canvas.chatWidth - canvas.itemSize
        const y = canvas.appH - canvas.itemSize
        const w = canvas.itemSize
        const h = canvas.itemSize
        return new SectionBgView(x, y, w, h, canvas.app.stage, true)
    }

    protected repositionButton(button: UIGameActionButtonView, row: number, column: number) {
        const canvas = this.uiGameManager.canvasController
        const padding = canvas.margin
        button.x = padding + column * canvas.itemSize
        button.y = padding - (row * canvas.itemSize)
        button.width = canvas.itemSize - (padding * 2)
        button.height = canvas.itemSize - (padding * 2)
        button.repositionedButton()
    }
}
